'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThMenuOutline = function TiThMenuOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 30c0.9 0 1.6 0.8 1.6 1.7s-0.7 1.6-1.6 1.6h-23.4c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7h23.4z m0-3.3h-23.4c-2.7 0-5 2.2-5 5s2.3 5 5 5h23.4c2.7 0 5-2.3 5-5s-2.3-5-5-5z m0-8.4c0.9 0 1.6 0.8 1.6 1.7s-0.7 1.7-1.6 1.7h-23.4c-0.9 0-1.6-0.8-1.6-1.7s0.7-1.7 1.6-1.7h23.4z m0-3.3h-23.4c-2.7 0-5 2.2-5 5s2.3 5 5 5h23.4c2.7 0 5-2.2 5-5s-2.3-5-5-5z m0-8.3c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7h-23.4c-0.9 0-1.6-0.7-1.6-1.7s0.7-1.6 1.6-1.6h23.4z m0-3.4h-23.4c-2.7 0-5 2.3-5 5s2.3 5 5 5h23.4c2.7 0 5-2.2 5-5s-2.3-5-5-5z' })
        )
    );
};

exports.default = TiThMenuOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-menu-outline.js
// module id = 3996
// module chunks = 0